import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

const crawlerPattern =
  /(googlebot\/|bot|Googlebot-Mobile|prerender|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)/i;

@Injectable()
export class UtilsService {
  constructor() {}

  validateEmail(email: string): boolean {
    const re =
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return re.test(String(email).toLowerCase());
  }

  validateName(text: string): boolean {
    const re =
      /^[A-Za-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ\- ]{2,}$/;
    return re.test(String(text));
  }

  validatePassword(text: string): boolean {
    const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;
    return re.test(String(text));
  }

  isCrawler(userAgent: string): boolean {
    return crawlerPattern.test(userAgent);
  }

  async fetchWithRetries(
    url: string | URL | Request,
    retries: number,
    options: RequestInit = {},
  ) {
    const res = await fetch(url, options);
    if (res.ok) {
      return res.json();
    }

    if (res.status >= 400 && res.status < 500) {
      throw new HttpErrorResponse({
        status: res.status,
        statusText: res.statusText,
      });
    }

    if (retries > 0) {
      return this.fetchWithRetries(url, retries - 1, options);
    }

    throw new HttpErrorResponse({
      status: res.status,
      statusText: res.statusText,
    });
  }

  generatePossesiveName(
    name: string,
    language: 'dk' | 'en' = 'dk',
    options?: { capitalize?: boolean },
  ) {
    const trimmed = name.trim();
    const result = trimmed.endsWith('s')
      ? `${trimmed}'`
      : language === 'dk'
        ? `${trimmed}s`
        : `${trimmed}'s`;

    if (options?.capitalize) {
      return result.charAt(0).toUpperCase() + result.slice(1);
    }

    return result;
  }
}
